/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Start_Page_Title_TailInputs */

const en_start_page_title_tail = /** @type {(inputs: Start_Page_Title_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`today.`)
};

const pl_start_page_title_tail = /** @type {(inputs: Start_Page_Title_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`jeszcze dziś.`)
};

/**
* | output |
* | --- |
* | "today." |
*
* @param {Start_Page_Title_TailInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const start_page_title_tail = /** @type {((inputs?: Start_Page_Title_TailInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Start_Page_Title_TailInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_start_page_title_tail(inputs)
	return en_start_page_title_tail(inputs)
});